export const INSTITUTS_MÉTIER: Map<string, string> = new Map([
  ['ICCB', 'Institut de la charpente et de la construction bois'],
  ['IEMAE', "Institut européen de l'agencement, de la menuiserie et de l'ébénisterie"],
  ['IMAF', "Institut des métiers de l'aménagement et de la finition"],
  ['IMC', 'Institut des métiers de la carrosserie'],
  ['IMCTI', 'Institut des métiers de la chaudronnerie et de la tuyauterie industrielle'],
  ['IMG', 'Institut des métiers du goût'],
  ['IMM', 'Institut des métiers de la maçonnerie'],
  ['IMNJP', 'Institut des métiers de la nature, du jardin et du paysage'],
  ['IMS', 'Institut des matériaux souples'],
  ['IMSGC', 'Institut des métiers du sanitaire et du génie climatique'],
  ['IMTA', 'Institut des métiers des technologies associées'],
  ['ISC', 'Institut supérieur de la couverture'],
  ['ISMB', 'Institut supérieur du métal dans le bâtiment'],
  ['ISRFMP', 'Institut supérieur de recherche et de formation aux métiers de la pierre'],
]);
